var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"monitor-item"},[_c(_vm.component.name,_vm._b({tag:"component",attrs:{"params":_vm.params,"payload":_vm.data},on:{"update":_vm.refresh,"init":_vm.refresh}},'component',_vm.component.options,false)),_vm._v(" "),(_vm.isLoading)?_c('div',{staticClass:"loader"},[_c('loader',{attrs:{"size":"60"}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }